import { useQuery } from "react-query";
import { QK } from "../base/qk";
import { getUserProfile } from "../api/services/user";

export const useCustomUserProfile = () => {
  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: [QK.userProfile],
    queryFn: getUserProfile,

    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    retry: 1,

    select: (response) => response?.data || response,
  });

  return {
    profile: data,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};